import { prNabc } from '../../../features/pcr/models/prNabc.V1'
import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { moveElementToPath, transformAndMoveData } from '../../object.util'

interface PrNegativeItem {
  name: string
  element: string
  code: number
}

interface TransformedItem {
  id: number
  name: string
  pn: string
  nv: string
}

export const glassgowCommaScore = (pcr: IPcr): IPcr => {
  try {
    if (pcr.prNegative && pcr.prNegative.length > 0) {
      pcr.prNabc = { ...prNabc }

      const mapping: Record<string, string> = {
        'eVitals.19': 'gcsEyePNNV',
        'eVitals.20': 'gcsVerbalPNNV',
        'eVitals.21': 'gcsMotorPNNV',
        'eVitals.23': 'gcsPNNV',
      }

      const nemsisCodeMapping: Record<number, string> = {
        7701001: 'Not Applicable',
        7701003: 'Not Recorded',
        7701005: 'Not Reporting',
        8801019: 'Refused',
        8801023: 'Unable to Complete',
      }

      const transformFn = (sourceObj: PrNegativeItem): TransformedItem => {
        const isPN = [8801019, 8801023].includes(sourceObj.code)
        const isNV = [7701001, 7701003, 7701005].includes(sourceObj.code)

        return {
          id: sourceObj.code,
          name: nemsisCodeMapping[sourceObj.code],
          pn: isPN ? sourceObj.code.toString() : '',
          nv: isNV ? sourceObj.code.toString() : '',
        }
      }

      transformAndMoveData(
        'prNegative',
        'prNabc',
        pcr,
        transformFn,
        (item: PrNegativeItem) => Object.prototype.hasOwnProperty.call(mapping, item?.element),
        mapping,
        true
      )
    }
    const realValuesAndToggleMigration = [
      { from: 'prNabc.gcs1', to: 'prNabc.gcs' },
      { from: 'prNabc.gcsEye1', to: 'prNabc.gcsEye' },
      { from: 'prNabc.gcsMotor1', to: 'prNabc.gcsMotor' },
      { from: 'prNabc.gcsVerbal1', to: 'prNabc.gcsVerbal' },
      {
        from: '_uiPlaceHolder.gcsPlaceholders._isGcsEye2Enabled',
        to: '_uiPlaceHolder.gcsPlaceholders._isGcsEyePNNVEnabled',
      },
      {
        from: '_uiPlaceHolder.gcsPlaceholders._isGcsVerbal2Enabled',
        to: '_uiPlaceHolder.gcsPlaceholders._isGcsVerbalPNNVEnabled',
      },
      {
        from: '_uiPlaceHolder.gcsPlaceholders._isGcsMotor2Enabled',
        to: '_uiPlaceHolder.gcsPlaceholders._isGcsMotorPNNVEnabled',
      },
      { from: '_uiPlaceHolder.gcsPlaceholders._isGcs2Enabled', to: '_uiPlaceHolder.gcsPlaceholders._isGcsPNNVEnabled' },
    ]

    realValuesAndToggleMigration.forEach(({ from, to }) => moveElementToPath(pcr, from, to))
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule glassgowCommaScore ${error}`)
    throw error
  }
}
